import common from "./de.json";
import { deTranslations as login } from "../../pages/LocalLogin/translations";
import { deTranslations as paymentMethods } from "../../pages/PaymentMethods/translations";
import { deTranslations as dashboard } from "../../pages/Dashboard/translations";
import { deTranslations as invoices } from "../../pages/Invoices/translations";
import { deTranslations as payInvoices } from "../../pages/PayInvoices/translations";
import { deTranslations as invoice } from "../../pages/Invoice/translations";
import { deTranslations as securityDeposit } from "../../pages/SecurityDeposit/translations";

export default {
  common,
  login,
  dashboard,
  paymentMethods,
  invoices,
  payInvoices,
  invoice,
  securityDeposit,
};
